import { createAsyncThunk } from '@reduxjs/toolkit';
import { shopService, siteService } from 'services';
import * as Types from 'types';

export const getShopWorkersChargeSiteList = createAsyncThunk<
  Types.getShopWorkersChargeSiteListResponse,
  Types.getShopWorkersChargeSiteListParams,
  Types.ThunkAPI<Types.GetWorkerError>
>('workShift/thunk/getShopWorkersChargeSiteList', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getShopWorkersChargeSiteList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkersChargeSiteList = createAsyncThunk<
  Types.getWorkersChargeSiteListResponse,
  Types.getWorkersChargeSiteListParams,
  Types.ThunkAPI<Types.GetWorkerError>
>('workShift/thunk/getWorkersChargeSiteList', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getWorkersChargeSiteList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const getCooperatorSchedules = createAsyncThunk<
  Types.GetShopSchedulesSelectResponse,
  Types.GetShopSchedulesSelectRequest,
  Types.ThunkAPI<Types.GetShopSchedulesSelectError>
>('workShift/thunk/CooperatorSchedules', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getShopSchedulesSelect(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const getUserSchedules = createAsyncThunk<
  Types.CooperatorUserSchedulesResponse,
  Types.GetCooperatorUserSchedulesRequest,
  Types.ThunkAPI<Types.GetCooperatorUserSchedulesError>
>('workShift/thunk/CooperatorUserSchedules', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getCooperatorUserSchedules({
      from_date: params?.from_date,
      to_date: params?.to_date,
    });
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkersSiteList = createAsyncThunk<
  Types.getWorkersSiteListResponse,
  Types.getWorkersSiteListRequest,
  Types.ThunkAPI<Types.getWorkersSiteListError>
>('workShift/thunk/getWorkersSiteList', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getWorkersSiteList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getUnpropertyListShop = createAsyncThunk<
  Types.GetUnpropertyListShopResponse,
  boolean,
  Types.ThunkAPI<Types.GetUnpropertyListShopError>
>('workShift/thunk/getUnpropertyListShop', async (_, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getUnpropertyListShop();
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2023/10/24 Leading Win 作業員シフト表廃止対応 start
export const findPropertyInfo = createAsyncThunk<
  Types.PropertyInfoResponse,
  Types.PropertyInfoRequest,
  Types.ThunkAPI<Types.PropertyInfoError>
>('workShift/thunk/findPropertyInfo', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.findPropertyInfo(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2023/10/24 Leading Win 作業員シフト表廃止対応 end
